import { MenuDetails } from './menu-details.model';


export class MenuAccessDto implements IMenuAccessDto {
    parentMenuName!: string | undefined;
    parentMenuId!: number;
    menuDetails!: MenuDetails[] | undefined;

    constructor(data?: IMenuAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentMenuName = _data["parentMenuName"];
            this.parentMenuId = _data["parentMenuId"];
            if (Array.isArray(_data["menuDetails"])) {
                this.menuDetails = [] as any;
                for (let item of _data["menuDetails"])
                    this.menuDetails!.push(MenuDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentMenuName"] = this.parentMenuName;
        data["parentMenuId"] = this.parentMenuId;
        if (Array.isArray(this.menuDetails)) {
            data["menuDetails"] = [];
            for (let item of this.menuDetails)
                data["menuDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuAccessDto {
    parentMenuName: string | undefined;
    parentMenuId: number;
    menuDetails: MenuDetails[] | undefined;
}

